"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.causeOfGraftlossMessages = exports.hasGraftlossMessages = exports.CauseOfGraftloss = exports.HasGraftloss = void 0;
const schema_1 = require("../../../../schema");
var HasGraftloss;
(function (HasGraftloss) {
    HasGraftloss["HAS_GRAFTLOSS"] = "has_graftloss";
    HasGraftloss["NO_UNKNOWN_GRAFTLOSS"] = "no_unknown_graftloss";
})(HasGraftloss || (exports.HasGraftloss = HasGraftloss = {}));
var CauseOfGraftloss;
(function (CauseOfGraftloss) {
    CauseOfGraftloss["ACUTE_REJECTION"] = "acute_rejection";
    CauseOfGraftloss["CHRONIC_REJECTION"] = "chronic_rejection";
    CauseOfGraftloss["PRIMARY_RENAL_DISEASE"] = "primary_renal_disease";
    CauseOfGraftloss["PRIMARY_NON_FUNCTION"] = "primary_non_function";
    CauseOfGraftloss["GRAFT_INFECTION"] = "graft_infection";
    CauseOfGraftloss["VASCULAR_PROBLEMS"] = "vascular_problems";
    CauseOfGraftloss["POSTRENAL_CAUSES"] = "postrenal_causes";
    CauseOfGraftloss["NON_SPECIFIC_GRAFT_FAILURE"] = "non_specific_graft_failure";
    CauseOfGraftloss["DEATH_WITH_FUNCTIONING_GRAFT"] = "death_with_functioning_graft";
    CauseOfGraftloss["NON_COMPLIENCE"] = "non-complience";
    CauseOfGraftloss["DE_NOVO_KIDNEY_DISEASE"] = "de_novo_kidney_disease";
    CauseOfGraftloss["UNKNOWN_CAUSE"] = "unknown_cause";
    CauseOfGraftloss["OTHER_CAUSE"] = "other_cause";
})(CauseOfGraftloss || (exports.CauseOfGraftloss = CauseOfGraftloss = {}));
exports.hasGraftlossMessages = {
    [HasGraftloss.HAS_GRAFTLOSS]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.hasGraftloss.HAS_GRAFTLOSS",
        defaultMessage: "Történt graftvesztés"
    },
    [HasGraftloss.NO_UNKNOWN_GRAFTLOSS]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.hasGraftloss.NO_UNKNOWN_GRAFTLOSS",
        defaultMessage: "Nem történt vagy nem ismert"
    }
};
exports.causeOfGraftlossMessages = {
    [CauseOfGraftloss.ACUTE_REJECTION]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.ACUTE_REJECTION",
        defaultMessage: "Akut rejekció"
    },
    [CauseOfGraftloss.CHRONIC_REJECTION]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.CHRONIC_REJECTION",
        defaultMessage: "Krónikus rejekció"
    },
    [CauseOfGraftloss.PRIMARY_RENAL_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.PRIMARY_RENAL_DISEASE",
        defaultMessage: "Elsődleges vesebetegség visszatérése"
    },
    [CauseOfGraftloss.PRIMARY_NON_FUNCTION]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.PRIMARY_NON_FUNCTION",
        defaultMessage: "Elsődleges működésképtelenség"
    },
    [CauseOfGraftloss.GRAFT_INFECTION]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.GRAFT_INFECTION",
        defaultMessage: "Graft infekció"
    },
    [CauseOfGraftloss.VASCULAR_PROBLEMS]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.VASCULAR_PROBLEMS",
        defaultMessage: "Vascularis problémák"
    },
    [CauseOfGraftloss.POSTRENAL_CAUSES]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.POSTRENAL_CAUSES",
        defaultMessage: "Postrenalis problémák"
    },
    [CauseOfGraftloss.NON_SPECIFIC_GRAFT_FAILURE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.NON_SPECIFIC_GRAFT_FAILURE",
        defaultMessage: "Nem specifikus graftelégtelenség"
    },
    [CauseOfGraftloss.DEATH_WITH_FUNCTIONING_GRAFT]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.DEATH_WITH_FUNCTIONING_GRAFT",
        defaultMessage: "Működő vesével meghalt"
    },
    [CauseOfGraftloss.NON_COMPLIENCE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.NON_COMPLIENCE",
        defaultMessage: "Non-complience"
    },
    [CauseOfGraftloss.DE_NOVO_KIDNEY_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.DE_NOVO_KIDNEY_DISEASE",
        defaultMessage: "Újonnan kialakult vesebetegség"
    },
    [CauseOfGraftloss.UNKNOWN_CAUSE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.UNKNOWN_CAUSE",
        defaultMessage: "Ismeretlen ok"
    },
    [CauseOfGraftloss.OTHER_CAUSE]: {
        id: "ktx.basicRegistrationData.waitingListData.graftloss.causeOfGraftloss.OTHER_CAUSE",
        defaultMessage: "Egyéb ok"
    }
};
const hasGraftloss = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasGraftloss.HAS_GRAFTLOSS).interpretation({
        vocab: "ktx",
        code: "has_graftloss"
    }),
    schema_1.Schema.singleChoiceItem(HasGraftloss.NO_UNKNOWN_GRAFTLOSS)
        .interpretation({ vocab: "ktx", code: "no_unknown_graftloss" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" })
]).interpretation({ vocab: "ktx", code: "has_graftloss_choice" });
const causeOfGraftloss = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.ACUTE_REJECTION)
        .interpretation({ vocab: "ktx", code: "acute_rejection" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.CHRONIC_REJECTION)
        .interpretation({ vocab: "ktx", code: "chronic_rejection" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.PRIMARY_RENAL_DISEASE)
        .interpretation({ vocab: "ktx", code: "primary_renal_disease" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.PRIMARY_NON_FUNCTION)
        .interpretation({ vocab: "ktx", code: "primary_non_function" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.GRAFT_INFECTION)
        .interpretation({ vocab: "ktx", code: "graft_infection" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.VASCULAR_PROBLEMS)
        .interpretation({ vocab: "ktx", code: "vascular_problems" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.POSTRENAL_CAUSES)
        .interpretation({ vocab: "ktx", code: "postrenal_causes" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.NON_SPECIFIC_GRAFT_FAILURE)
        .interpretation({ vocab: "ktx", code: "non_specific_graft_failure" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.DEATH_WITH_FUNCTIONING_GRAFT)
        .interpretation({ vocab: "ktx", code: "death_with_functioning_graft" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.NON_COMPLIENCE)
        .interpretation({ vocab: "ktx", code: "non-complience" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.DE_NOVO_KIDNEY_DISEASE)
        .interpretation({ vocab: "ktx", code: "de_novo_kidney_disease" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.UNKNOWN_CAUSE)
        .interpretation({ vocab: "ktx", code: "unknown_cause" })
        .tag({ vocab: "ktx", code: "cause_of_graftloss" }),
    schema_1.Schema.singleChoiceItem(CauseOfGraftloss.OTHER_CAUSE)
]);
const causeOfGraftlossOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../causeOfGraftloss} === "other_cause"`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "other_cause" })
    .tag({ vocab: "ktx", code: "cause_of_graftloss" }));
const graftloss = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasGraftloss} === "has_graftloss"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ causeOfGraftloss, causeOfGraftlossOther }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasGraftloss, graftloss })
    .interpretation({ vocab: "ktx", code: "graftloss_statement" })
    .tag({ vocab: "fyrms", code: "action" });
